module.exports = __webpack_public_path__ + "media/images/pages/telegram-dab1ad7d4134b94e4c179075ee4fa7d2.png";